<!--
 * @FileDescription: 首页（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="home-page">
    <div class="home-core-data" id="core">
      <div class="home-core-data-title">
        <span v-if="storeType == 1">基础数据</span>
        <span v-if="storeType == 2" style="font-size:24px;">核心数据</span>
      </div>
      <div class="home-core-data-row">
        <template v-if="storeType == 1">
            <div class="home-core-data-col" v-for="(item,index) in sumDataList" :key="index"
              :style="{ width: coreWidth+'px',marginLeft:0 }">
              <div class="col-data-left">
                <img :src="item.img" :style="{width: bottomImage+'px'}" alt="">
              </div>
              <div class="col-data-right">
                <span class="title-span" :style="{color: index==0?'#FFA238' :index==1? '#FFA238' :index==2?'#5FACFA' :'#FB7369'}">{{ item.name }}</span>
                <span class="price-span">¥ {{ item.amountPrice }}</span>
                <span class="today-span">今日：¥ {{ item.todayPrice }}</span>
                <span class="yesterday-span">昨日：¥ {{ item.yesterdayPrice }}</span>
              </div>
            </div>
        </template>
        <template v-if="storeType == 2">
            <div class="home-core-data-col homecloud" v-for="(item,index) in sumDataListCloud" :key="index"
              :style="{ width: coreWidthCloud+'px',marginLeft:0 }">
              <div class="col-data-left">
                <img :src="item.img"  alt="">
              </div>
              <div class="col-data-right">
                <span class="title-span" :style="{color: index==0?'#FFA238' :index==1? '#5FACFA' :'#FFA238' }">{{ item.name }}</span>
                <span class="price-span">¥ {{ item.amountPrice }}</span>
                <span class="today-span">今日：¥ {{ item.todayPrice }}</span>
                <span class="yesterday-span">昨日：¥ {{ item.yesterdayPrice }}</span>
              </div>
            </div>
        </template>
      </div>
    </div>
    <div class="home-work-navigation"  v-if="storeType == 1">
      <div class="work-navigation-title">
        <div class="title-left">
          <span class="text">导航</span>
          <img src="@/assets/image/daohang.png" alt="" class="image" @click="btnSetNavigation">
        </div>
      </div>
      <div class="work-navigation-content">
        <a-row class="work-navigation-row">
          <a-col :span="12" class="work-navigation-col" id="workbox">
            <div class="work-navigation-col-box">
              <div class="col-title">
                <span>销售</span>
              </div>
              <div class="col-step-image" :style="{width: 25*sellNum+'%'}">
                <span v-for="(item,index) in sell" :key="index" class="col-image-name" @click="btGoMenuPage(item)">
                  <span v-if="item.isShow&&item.type==0" class="image-name-box"
                    :style="{ width: getImageNameWidth(index,sell.length)  }">
                    <img :src="item.img" alt="" class="image procurement-num"
                      :style="{width: imageWidth+'px', height: imageWidth+'px'}">
                    <span>{{ item.name }}</span>
                  </span>
                  <img :src="item.tagimg" alt="" class="step-image" v-if="item.tagimg&&(index+1)!=sell.length">
                </span>
              </div>
            </div>
          </a-col>
          <a-col :span="12" class="work-navigation-col" id="workbox">
            <div class="work-navigation-col-box">
              <div class="col-title">
                <span>采购</span>
              </div>
              <div class="col-step-image" :style="{width: 25*procurementNum+'%'}">
                <span v-for="(item,index) in procurement" :key="index" class="col-image-name"
                  @click="btGoMenuPage(item)">
                  <span v-if="item.isShow&&item.type==0" class="image-name-box"
                    :style="{ width: getImageNameWidth(index,procurement.length) }">
                    <img :src="item.img" alt="" class="image procurement-num"
                      :style="{width: imageWidth+'px', height: imageWidth+'px'}">
                    <span>{{ item.name }}</span>
                  </span>
                  <img :src="item.tagimg" alt="" class="step-image" v-if="item.tagimg&&(index+1)!=procurement.length">
                </span>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row class="work-navigation-row">
          <a-col :span="12" class="work-navigation-col" id="workbox">
            <div class="work-navigation-col-box">
              <div class="col-title">
                <span>库存</span>
              </div>
              <div class="col-step-image" :style="{width: 25*repertoryNum+'%'}">
                <span v-for="(item,index) in repertory" :key="index" class="col-image-name" @click="btGoMenuPage(item)">
                  <img :src="item.tagimg" alt="" class="step-image" v-if="item.tagimg&&item.taglocation=='left'">
                  <span v-if="item.isShow&&item.type==0" class="image-name-box"
                    :style="{ width:getImageNameWidth(index,repertory.length) }">
                    <img :src="item.img" alt="" class="image procurement-num"
                      :style="{width: imageWidth+'px', height: imageWidth+'px'}">
                    <span>{{ item.name }}</span>
                  </span>
                  <img :src="item.tagimg" alt="" class="step-image" v-if="item.tagimg&&item.taglocation=='right'">
                </span>
              </div>
            </div>
          </a-col>
          <a-col :span="12" class="work-navigation-col" id="workbox">
            <div class="work-navigation-col-box">
              <div class="col-title">
                <span>财务</span>
              </div>
              <div class="col-step-image" style="width: 75%">
                <span v-for="(item,index) in finance" :key="index" class="col-image-name"
                  @click="btGoMenuPage(item)">
                  <img :src="item.tagimg" alt="" class="step-image" v-if="item.tagimg&&item.taglocation=='left'">
                  <span v-if="item.isShow&&item.type==0" class="image-name-box"
                    :style="{ width:getImageNameWidth(index,finance.length) }">
                    <img :src="item.img" alt="" class="image procurement-num"
                      :style="{width: imageWidth+'px', height: imageWidth+'px'}">
                    <span>{{ item.name }}</span>
                  </span>
                  <img :src="item.tagimg" alt="" class="step-image" v-if="item.tagimg&&item.taglocation=='right'">
                </span>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="home-work-navigation navcloud" v-if="storeType == 2">
      <div class="work-navigation-title">
        <div class="title-left">
          <span class="text" style="font-size:24px;">工作导航</span>
        </div>
      </div>
      <div class="work-navigation-content">
        <a-row class="work-navigation-row">
          <a-col :span="12" class="work-navigation-col" id="workbox">
            <div class="work-navigation-col-box">
              <div class="col-title">
                <span>商品</span>
              </div>
              <div class="col-step-image">
                <span class="col-image-name" @click="btGoMenuPagecloud(1)">
                    <span class="image-name-box">
                      <img src="@/assets/image/6.png" alt="">
                      <span>商品库</span>
                    </span>
                </span>
              </div>
            </div>
          </a-col>
          <a-col :span="12" class="work-navigation-col" id="workbox">
            <div class="work-navigation-col-box">
              <div class="col-title">
                <span>销售</span>
              </div>
             <div class="col-step-image">
                <span class="col-image-name" @click="btGoMenuPagecloud(2)">
                    <span class="image-name-box">
                      <img src="@/assets/image/2.png" alt="">
                      <span>销售订单</span>
                    </span>
                </span>
                <span class="col-image-name" @click="btGoMenuPagecloud(3)">
                    <span class="image-name-box">
                      <img src="@/assets/image/28@3x.png" alt="">
                      <span>售后列表</span>
                    </span>
                </span>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row class="work-navigation-row">
          <a-col :span="12" class="work-navigation-col" id="workbox">
            <div class="work-navigation-col-box">
              <div class="col-title">
                <span>分销</span>
              </div>
               <div class="col-step-image">
                <span class="col-image-name" @click="btGoMenuPagecloud(4)">
                    <span class="image-name-box">
                      <img src="@/assets/image/30@3x.png" alt="">
                      <span>分销账单</span>
                    </span>
                </span>
                <span class="col-image-name" @click="btGoMenuPagecloud(5)">
                    <span class="image-name-box">
                      <img src="@/assets/image/31@3x.png" alt="">
                      <span>分销关系</span>
                    </span>
                </span>
              </div>
            </div>
          </a-col>
          <a-col :span="12" class="work-navigation-col" id="workbox">
            <div class="work-navigation-col-box">
              <div class="col-title">
                <span>账户</span>
              </div>
              <div class="col-step-image">
                <span class="col-image-name" @click="btGoMenuPagecloud(6)">
                    <span class="image-name-box">
                      <img src="@/assets/image/32@3x.png" alt="">
                      <span>提现管理</span>
                    </span>
                </span>
                <span class="col-image-name" @click="btGoMenuPagecloud(7)">
                    <span class="image-name-box">
                      <img src="@/assets/image/33@3x.png" alt="">
                      <span>个人分销账户</span>
                    </span>
                </span>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <set-navigation ref="navigation" @btnColse="btnColse"></set-navigation>
  </div>
</template>

<script>
import setNavigation from "./modules/setNavigation.vue";
import { getCoreData, getListEditable,getCoreDataCloud } from "@/utils/api";
import Template from '../../template.vue';
export default {
  name: "home",
  components: {
    setNavigation,
  },
  data() {
    return {
      showIcon: false,
      coreWidth: "",
      coreWidthCloud:'',
      stepWidth: "",
      imageWidth: "",
      distanceWidth: "",
      bottomImage: "",
      sell: [
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "销售报价",
          img: require("@/assets/image/1.png"),
          tagimg: require("@/assets/image/15.png"),
          taglocation: "right",
          url: "/sales/selladmin/makeOffers",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "销售订单",
          img: require("@/assets/image/2.png"),
          tagimg: require("@/assets/image/15.png"),
          taglocation: "right",
          url: "/sales/selladmin/sellOrder",
        },
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "销售出库",
          img: require("@/assets/image/3.png"),
          tagimg: require("@/assets/image/15.png"),
          taglocation: "right",
          url: "/sales/selladmin/comeWarehouse",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "销售退货",
          img: require("@/assets/image/4.png"),
          url: "/sales/selladmin/enterWarehouse",
        },
      ],
      procurement: [
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "采购询货",
          img: require("@/assets/image/5.png"),
          tagimg: require("@/assets/image/18.png"),
          taglocation: "right",
          url: "/purchase/purchaseasmin/enquiry",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "采购订单",
          img: require("@/assets/image/6.png"),
          tagimg: require("@/assets/image/18.png"),
          taglocation: "right",
          url: "/purchase/purchaseasmin/purchaseOrder",
        },
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "采购入库",
          img: require("@/assets/image/7.png"),
          tagimg: require("@/assets/image/18.png"),
          taglocation: "right",
          url: "/purchase/purchaseasmin/purchaseEnterWarehouse",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "采购退货",
          img: require("@/assets/image/8.png"),
          url: "/purchase/purchaseasmin/purchaseGoWarehouse",
        },
      ],
      repertory: [
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "库存盘点",
          img: require("@/assets/image/9.png"),
          tagimg: require("@/assets/image/19.png"),
          taglocation: "right",
          url: "/librarymanage/warehousemanage/inventorycheck",
        },
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "库存查询",
          img: require("@/assets/image/10.png"),
          url: "/librarymanage/warehousemanage/materialmanage",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "库存调拨",
          img: require("@/assets/image/11.png"),
          tagimg: require("@/assets/image/20.png"),
          taglocation: "left",
          url: "/librarymanage/warehousemanage/warehousemanage",
        },
      ],
      finance: [
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "收款单",
          img: require("@/assets/image/12.png"),
          tagimg: require("@/assets/image/21.png"),
          taglocation: "right",
          url: "/finance/voucher/receiptOrder",
        },
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "应收应付款",
          img: require("@/assets/image/13.png"),
          url: "/finance/financedata/receiptPayment",
        },
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "付款单",
          img: require("@/assets/image/14.png"),
          tagimg: require("@/assets/image/22.png"),
          taglocation: "left",
          url: "/finance/voucher/paymentOrder",
        },
      ],
      sell: [],
      procurement: [],
      repertory: [],
      sellNum: 4,
      procurementNum: 4,
      repertoryNum: 3,
      sumDataListCloud:[
         {
            name: "销售额",
            amountPrice: 0,
            todayPrice: 0,
            yesterdayPrice: 0,
            img: require("@/assets/image/xiaoshou_img1@3x.png"),
          },
           {
            name: "订单量",
            amountPrice: 0,
            todayPrice: 0,
            yesterdayPrice: 0,
            img: require("@/assets/image/dingdan_img1@3x.png"),
          },
           {
            name: "分销佣金",
            amountPrice: 0,
            todayPrice: 0,
            yesterdayPrice: 0,
            img: require("@/assets/image/fenxiao_img1@3x.png"),
          },
      ],
      sumDataList: [
        {
          name: "销售额",
          amountPrice: 0,
          todayPrice: 0,
          yesterdayPrice: 0,
          img: require("@/assets/image/xiaoshoue.png"),
        },
        {
          name: "销售毛利润",
          amountPrice: 0,
          todayPrice: 0,
          yesterdayPrice: 0,
          img: require("@/assets/image/xiaoshoumaolurun.png"),
        },
        {
          name: "采购额",
          amountPrice: 0,
          todayPrice: 0,
          yesterdayPrice: 0,
          img: require("@/assets/image/caigoue.png"),
        },
        {
          name: "收款金额",
          amountPrice: 0,
          todayPrice: 0,
          yesterdayPrice: 0,
          img: require("@/assets/image/shoukuanjine.png"),
        },
        {
          name: "付款金额",
          amountPrice: 0,
          todayPrice: 0,
          yesterdayPrice: 0,
          img: require("@/assets/image/fukuanjine.png"),
        },
      ],
      isHeightSize: 0,
      workheight:0,
      timer:null,
      storeType:'',
    };
  },
  activated() {
    let _that = this
    _that.storeType = localStorage.getItem('storeType')
    setTimeout(function () {
      _that.workheight = document.getElementById('workbox').offsetHeight*0.1
      let width = document.getElementById("core").offsetWidth;
      _that.coreWidth = (width - 110) / 5;
      _that.coreWidthCloud = (width - 110) / 3;
      _that.imageWidth = parseInt(width * 0.0337);
      _that.distanceWidth = parseInt(width * 0.024);
      _that.bottomImage = parseInt(width * 0.0265);
    }, 50)
    if(_that.storeType == 1){
       this.getHomeCoreData();
    }else{
        this.getHomeCoreDataCloud();
    }
    this.btnColse();

    let height = document.getElementById("content").offsetHeight;
    if (height > 50) {
      this.isHeightSize = 0;
    } else {
      this.isHeightSize = 1;
    }
    let shopid = localStorage.getItem('shopid')
    if(this.$store.state.shopId != shopid){
        localStorage.setItem('transactorName', JSON.stringify({
            transactorId: undefined,
            transactorName: undefined
        }))
        localStorage.setItem('outStorageName', JSON.stringify({
            outStorageId: undefined,
            outStorageName:undefined
        }))
        localStorage.setItem('intStorageName', JSON.stringify({
            intStorageId: undefined,
        }))
        localStorage.setItem('shopid',this.$store.state.shopId)
    }
    // this.timer = setInterval(()=>{
    //   _that.getHomeCoreData()
    // },60000)

  },
  // beforeRouteLeave(to, from, next) {
  //   clearInterval(this.timer)
  //   next()
  // },
  methods: {
    //   获取宽度
    getImageNameWidth(index, num) {
      let width = null;
      if (index == 0) {
        width = this.imageWidth + this.distanceWidth + "px";
      } else if (index + 1 == num) {
        width = this.imageWidth + this.distanceWidth + "px";
      } else {
        width = this.imageWidth + this.distanceWidth * 2 + "px";
      }
      return width;
    },
    // 设置导航
    btnSetNavigation() {
      this.$refs.navigation.showModal();
    },
    // 关闭回调
    btnColse() {
      let params = {};
      let header = {};
      let data = {
        companyStoreId: this.$store.state.userInfo.companyStoreId,
      };
      let List = [];
      this.$store.state.isLoding = true;
      getListEditable(params, header, data).then((res) => {
        if (res.code == 200) {
          res.result.map((item) => {
            if (item.closeFlag == 1) {
              List.push(item.name);
            }
          });
          this.setMenuValue();
          List.map((item, index) => {
            this.sell.map((ite, inde) => {
              if (item == ite.name) {
                this.sell.splice(inde, 1);
              }
            });
            this.procurement.map((ite, inde) => {
              if (item == ite.name) {
                this.procurement.splice(inde, 1);
              }
            });
            this.repertory.map((ite, inde) => {
              if (item == ite.name) {
                this.repertory.splice(inde, 1);
              }
            });
          });
          this.$store.state.isLoding = false;
        } else {
          this.$message.error(res.logMessage)
        }
      });
    },
    setMenuValue() {
      this.sell = [
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "销售报价",
          img: require("@/assets/image/1.png"),
          tagimg: require("@/assets/image/15.png"),
          taglocation: "right",
          url: "/sales/selladmin/makeOffers",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "销售订单",
          img: require("@/assets/image/2.png"),
          tagimg: require("@/assets/image/15.png"),
          taglocation: "right",
          url: "/sales/selladmin/sellOrder",
        },
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "销售出库",
          img: require("@/assets/image/3.png"),
          tagimg: require("@/assets/image/15.png"),
          taglocation: "right",
          url: "/sales/selladmin/comeWarehouse",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "销售退货",
          img: require("@/assets/image/4.png"),
          url: "/sales/selladmin/enterWarehouse",
        },
      ];
      this.procurement = [
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "采购询货",
          img: require("@/assets/image/5.png"),
          tagimg: require("@/assets/image/18.png"),
          taglocation: "right",
          url: "/purchase/purchaseasmin/enquiry",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "采购订单",
          img: require("@/assets/image/6.png"),
          tagimg: require("@/assets/image/18.png"),
          taglocation: "right",
          url: "/purchase/purchaseasmin/purchaseOrder",
        },
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "采购入库",
          img: require("@/assets/image/7.png"),
          tagimg: require("@/assets/image/18.png"),
          taglocation: "right",
          url: "/purchase/purchaseasmin/purchaseEnterWarehouse",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "采购退货",
          img: require("@/assets/image/8.png"),
          url: "/purchase/purchaseasmin/purchaseGoWarehouse",
        },
      ];
      this.repertory = [
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "库存盘点",
          img: require("@/assets/image/9.png"),
          tagimg: require("@/assets/image/19.png"),
          taglocation: "right",
          url: "/librarymanage/warehousemanage/inventorycheck",
        },
        {
          isShow: true,
          isEdit: false,
          type: 0,
          name: "库存查询",
          img: require("@/assets/image/10.png"),
          url: "/librarymanage/warehousemanage/materialmanage",
        },
        {
          isShow: true,
          isEdit: true,
          type: 0,
          name: "库存调拨",
          img: require("@/assets/image/11.png"),
          tagimg: require("@/assets/image/20.png"),
          taglocation: "left",
          url: "/librarymanage/warehousemanage/warehousemanage",
        },
      ];
    },
    //新手必做
    btnMustdo() {
      this.$router.push("/systemoverview/overview/mustdo");
    },
    getHomeCoreDataCloud(){
        getCoreDataCloud({},{
          companyStoreId: this.$store.state.userInfo.companyStoreId,
        },{
           companyStoreId: this.$store.state.userInfo.companyStoreId,
        }).then((res)=>{
          if(res.code == 200){
            this.sumDataListCloud.map((item,index)=>{
              if(index == 0){
                item.amountPrice = res.result.totalSalesAmount
                item.todayPrice = res.result.todaySalesAmount
                item.yesterdayPrice = res.result.yesterdaySalesAmount
              }else if(index == 1){
                item.amountPrice = res.result.totalOrderCount
                item.todayPrice = res.result.todayOrderCount
                item.yesterdayPrice = res.result.yesterdayOrderCount
              }else if(index == 2){
                item.amountPrice = res.result.totalCommissionAmount
                item.todayPrice = res.result.currentMonthCommissionAmount
                item.yesterdayPrice = res.result.lastMonthCommissionAmount
              }
            })
          }
        })
    },
    // 获取核心数据
    getHomeCoreData() {
      let params = {
        companyStoreId: this.$store.state.userInfo.companyStoreId,
      };
      getCoreData(params).then((res) => {
        if (res.code == 200) {
          this.sumDataList.map((item, index) => {
            if (index == 0) {
              item.amountPrice = res.result[0].salesTotalAmount;
              item.todayPrice = res.result[1].salesTotalAmount;
              item.yesterdayPrice = res.result[2].salesTotalAmount;
            } else if (index == 1) {
              item.amountPrice = res.result[0].grossProfit;
              item.todayPrice = res.result[1].grossProfit;
              item.yesterdayPrice = res.result[2].grossProfit;
            } else if (index == 2) {
              item.amountPrice = res.result[0].purchaseTotalAmount;
              item.todayPrice = res.result[1].purchaseTotalAmount;
              item.yesterdayPrice = res.result[2].purchaseTotalAmount;
            } else if (index == 3) {
              item.amountPrice = res.result[0].collectionTotalAmount;
              item.todayPrice = res.result[1].collectionTotalAmount;
              item.yesterdayPrice = res.result[2].collectionTotalAmount;
            } else if (index == 4) {
              item.amountPrice = res.result[0].paymentTotalAmount;
              item.todayPrice = res.result[1].paymentTotalAmount;
              item.yesterdayPrice = res.result[2].paymentTotalAmount;
            }
          });
        } else {
          this.$message.error(res.logMessage)
        }
      });
    },
    // 跳转页面
    btGoMenuPage(item) {
      this.$router.push({ path: item.url });
    },
    btGoMenuPagecloud(index){
      console.log(index)
      if(index == 1){
        this.$router.push('/commoditycloud/commodityLibrarycloud/commoditycloudManagement')
      }else if(index == 2){
        this.$router.push('/cloudstore/sales/selladmin/salesOrder')
      }else if(index == 3){
        this.$router.push('/cloudstore/sales/selladmin/afterSales')
      }else if(index == 4){
        this.$router.push('/marketing/marketmanage/marketorder')
      }else if(index == 5){
        this.$router.push('/marketing/marketmanage/marketRelationship')
      }else if(index == 6){
        this.$router.push('/financecloud/financedatamanage/withdrawal')
      }else if(index == 7){
        this.$router.push('/financecloud/financedatamanage/personal')
      }
    }
  },
};
</script>
<style lang="scss">
.home-page {
  height: calc(100vh - 145px);
  .navcloud{
      padding: 30px 34px 16px 34px !important;
      .col-title{
        color: #455986 !important;
        font-size: 24px !important;
      }
      .col-image-name{
        margin-right: 107px;
      }
      .image-name-box{
        font-size: 20px !important;
         color: #455986 !important;
        img{
          width: 130px;
          height: 130px;
        }

      }

  }
  .home-work-navigation {
    height: calc(100vh - 445px);
    padding: 0 34px 16px 34px;
    background-color: #ffffff;
    .work-navigation-title {
      height: 50px;
      display: flex;
      justify-content: space-between;
      .title-left {
        font-size: 20px;
        font-weight: bold;
        .text {
          padding: 0 10px 0 4px;
        }
        .image {
          width: 18px;
          height: 18px;
        }
      }
      .title-right {
        cursor: pointer;
        font-size: 14px;
        color: #f76f14;
        .image {
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }
      }
    }
    .work-navigation-content {
      .work-navigation-row {
        height: calc((100vh - 565px) / 2);
        display: flex;
        margin-bottom: 12px;
        .work-navigation-col {
          height: 100%;
          margin: 0 6px;
          background-color: #fafafa;
          border-radius: 20px;
          .work-navigation-col-box {
            height: 100%;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            .col-title {
              color: #455986;
              font-size: 16px;
              font-weight: bold;
              padding: 20px 24px;
            }
          }
          .work-navigation-col-box-small {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .col-title {
              color: #455986;
              font-size: 16px;
              font-weight: bold;
              padding: 0 0 0 30px;
            }
          }

          .col-step-image {
            height: calc((100vh - 565px) / 3.5);
            padding: 0 45px;
            display: flex;
            align-items: center;

            .col-image-name {
              display: flex;
              align-items: center;
              justify-content: center;
              color: #465a86;
              font-size: 16px;
              cursor: pointer;
              .image-name-box {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .image {
                  width: 84px !important;
                  height: auto !important;
                }
              }
            }

            .image {
              width: 90px;
              height: 90px;
            }
            .step-image {
              height: 18px;
              margin-bottom: 25px;
            }

          }
        }
      }
    }
  }
  .home-core-data {
    height: 278px;
    background-color: #ffffff;
    .home-core-data-title {
      height: 80px;
      line-height: 80px;
      font-size: 20px;
      padding: 0 40px;
      font-weight: bold;
    }
    .home-core-data-row {
      padding: 0 24px;
      display: flex;
      justify-content: space-between;
      .homecloud{
        height: 200px !important;
          .col-data-left{
            width: 130px !important;
            margin-right: 30px;
            img{
                width: 100%;
                height: 100%;
            }
          }
          .col-data-right{
             .title-span{
               font-size: 24px !important;
            }
            .price-span{
              font-size: 32px !important;
              margin: 10px 0 10px;
            }
            .today-span,.yesterday-span{
              font-size: 18px;
            }

          } 
      }
      .home-core-data-col {
        height: 168px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 3px 4px 20px 0px rgba(73, 97, 116, 0.1);
        border-radius: 35px;
        padding: 0 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding:0 44px;
        .col-data-left {
          width: 70px;
          image {
            width: 70px;
            height: auto;
          }
        }
        .col-data-right {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .title-span {
            font-size: 18px;
            font-weight: bold;
          }
          .price-span {
            font-size: 24px;
            font-weight: bold;
            color: #465a86;
            padding: 10px 0 7px 0;
          }
        }
      }
    }
  }
}
</style>
